import React from "react";
import { WEInfoGS } from "../card/WorkedExampleInfo";

const ListWorkedExamples = ({ id, workedExamples = [], buttons, maxHeight = '100px' }) => {
  return (
    <>
      {workedExamples.length > 0 && (
        <div className="flex flex-col gap-1 w-full">
          {workedExamples.map((example) => (
            <div
              key={`${id}-item-worked-examples-${example._id}`}
              className="rounded bg-loading"
            >
              <WEInfoGS
                key={example._id}
                row={example}
                maxHeight={maxHeight}
                buttons={buttons ? buttons(example) : null}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default ListWorkedExamples;
